/* prettier-ignore */

import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { NewCustomRouteService } from '../../../../new-custom-route.service';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SendUpdateRouteService } from 'src/app/pages/send-update-route/send-update-route.service';
import { AuthService } from 'src/app/auth/services';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'map-action-buttons',
  imports: [CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class ActionButtonsComponent {
    public translate = inject(TranslateService);
    public authService = inject(AuthService);
    private tools = inject(ToolsService);
    public isTechEditMode = computed(() => this.tools.isTechEditMode());
    public isTechMode = computed(() => this.tools.isTechMode());
    private routeService = inject(NewCustomRouteService);
    private router = inject(Router);
    private sendUpdateService = inject(SendUpdateRouteService);
    public isLoadFromApi = computed(() => this.sendUpdateService.userData()?.id);
    public disableTouch = computed(() => this.routeService.disableTouch())
    public isPlannerMode = computed(() => this.tools.isPlannerMode())

    sendRoute(){
        this.router.navigateByUrl('/send-update-route');
    }

    saveRoute(){
        this.sendUpdateService.item.update(prev => ({...prev, route_days: this.routeService.route()?.length}))
        this.router.navigateByUrl('/save-recommended-route');
    }

    changeStartEndLocation(){
        this.routeService.openModalStartEnd();
    }

    downloadRoute(){
        const jsonString = JSON.stringify(this.routeService.route(), null, 2); 
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'route.json'; // nombre que tendrá el archivo al descargarse
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    createNewRoute(){
        this.router.navigateByUrl('/register-user');
    }

}